import { TFunction } from "i18next";
import { UseFieldArrayReturn } from "react-hook-form";
import { NewOrderPartyType } from "v2-types/order";
import { chargesPayeePayerForm } from "../services";

export const getTitle = (
  t: TFunction,
  kind: 'Payee' | 'Payer' | 'Tax' | 'Proprietor' | 'Ownership'
): string => {
  switch (kind) {
    case "Payee":
      return t('charges:select-payees', { defaultValue: 'Select Payees' });
    case "Tax":
      return t('charges:select-parties', { defaultValue: 'Select Parties' });
    case "Payer":
      return t('charges:select-payers', { defaultValue: 'Select Payers' });
    case "Proprietor":
      return t('charges:select-proprietors', { defaultValue: 'Select Proprietors' });
    case "Ownership":
      return t('charges:select-ownerships', { defaultValue: 'Select Ownerships' });
    default:
      return "";
  }
};

export const filterParties = (
  parties: NewOrderPartyType[],
  kind: 'Payee' | 'Payer' | 'Tax' | 'Proprietor' | 'Ownership',
  partiesSelected: UseFieldArrayReturn<chargesPayeePayerForm, 'InvolvedParties', 'id'>,
  excludedLetters: string[],
  showAllParties: boolean,
  letter?: string
) => {
  const result = parties
    .filter((party) => !partiesSelected.fields.some(({ party_id }) => party_id === party._id));

  if (showAllParties || (kind === "Payee" && letter && excludedLetters.includes(letter))) {
    return result;
  }

  let regex = /^(underwriter|title company)$/i;

  if (kind === "Tax") regex = /^tax/i;

  if (kind === "Payer") regex = /^(buyer|seller)$/i;

  if (kind === "Proprietor") regex = /^seller/i;

  if (kind === "Ownership") regex = /^buyer/i;

  return result
    .filter((party) => {
      return party.kinds.some((k) => regex.test(k));
    });
};